export const minBestMaxValidation = (minGlobal, bestGlobal, maxGlobal, fields, field) => {
  const hasValue = (val) => val !== null && val !== undefined && val !== '' && !Number.isNaN(Number(val))
  const min = hasValue(minGlobal) ? Number(minGlobal) : ''
  const best = hasValue(bestGlobal) ? Number(bestGlobal) : ''
  const max = hasValue(maxGlobal) ? Number(maxGlobal) : ''

  const method = {
    min: () => {
      if (min !== '') {
        if (max !== '') {
          if (min > max) {
            return { field: fields.min, error: 'Min should be less than or equal to max' }
          }
        }
        if (best !== '') {
          if (min > best) {
            return { field: fields.min, error: 'Min should be less than or equal to best' }
          }
        }
      }

      return { field: '', error: '' }
    },
    best: () => {
      if (best !== '') {
        if (min !== '') {
          if (best < min) {
            return { field: fields.best, error: 'Best should be greater than or equal to min' }
          }
        }
        if (max !== '') {
          if (best > max) {
            return { field: fields.best, error: 'Best should be less than or equal to max' }
          }
        }
      }

      return { field: '', error: '' }
    },
    max: () => {
      if (max !== '') {
        if (min !== '') {
          if (min > max) {
            return { field: fields.max, error: 'Max should be greater than or equal to min' }
          }
        }
        if (best !== '') {
          if (best > max) {
            return { field: fields.max, error: 'Max should be greater than or equal to best' }
          }
        }
      }

      return { field: '', error: '' }
    }
  }

  return method[field]()
}

export const minMaxValidation = (minGlobal, maxGlobal, fields, field) => {
  // Treat only null/undefined/'' as "not provided" so a numeric 0 is still compared.
  const min = minGlobal === null || minGlobal === undefined || minGlobal === '' ? '' : Number(minGlobal)
  const max = maxGlobal === null || maxGlobal === undefined || maxGlobal === '' ? '' : Number(maxGlobal)

  const method = {
    year_min: () => {
      if (max !== ''){
        if (min > max){
          return { field: fields.year_min, error: 'Min should be less than or equal to max'}
        }
      }
      return { field: '', error: '' }
    },
    year_max: () => {
      if (min !== ''){
        if (max < min){
          return { field: fields.year_max, error: 'Max should be greater than or equal to min'}
        }
      }
      return { field: '', error: '' }
    },
    min: () => {
      if (min !== '' && max !== ''){
        if (min > max){
          return { field: fields.min, error: 'Min should be less than or equal to max'}
        }
      }
      return { field: '', error: '' }
    },
    max: () => {
      if (min !== '' && max !== ''){
        if (max < min){
          return { field: fields.max, error: 'Max should be greater than or equal to min'}
        }
      }
      return { field: '', error: '' }
    }
  }

  return method[field]()
}


